import React, { useEffect, useRef, useState } from 'react';
import './footer.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../api/api';
import { setFilterSearch, setFilterBrands, setFilterMinMaxPrice, setFilterCategory } from '../../model/reducer/productFilterReducer';
import { setCategory } from '../../model/reducer/categoryReducer';
import { useTranslation } from 'react-i18next';
import FooterBrand from '../brands/FooterBrand';
import truck from '../../utils/image/delivery-truck.png';
import updown from '../../utils/image/up-and-down-arrows.png';
import customerService from '../../utils/image/customer-service.png';
import moneyBack from '../../utils/image/money-back.png';
import certi1 from '../../utils/image/certi1.png';
import certi2 from '../../utils/image/certi2.png';
import contacticon from '../../utils/image/contact.png';
import envelope from '../../utils/image/envelope.png';
import paypal_svg from '../../utils/ic_paypal.svg';
import paytm_svg from '../../utils/ic_paytm.svg';
import cod_svg from '../../utils/ic_cod.svg';
import upi_svg from '../../utils/ic_upi.svg';
import razorpay_svg from '../../utils/ic_razorpay.svg';
import whatsappimg from "../../utils/image/whatsapp.png";


export const Footer = () => {
    const searchNavTrigger = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const setting = useSelector(state => state.setting);
    const curr_url = useLocation();
    const { t } = useTranslation();

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(5); // Default value

    const fetchCategory = (id = 0) => {
        api.getCategory(id)
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    dispatch(setCategory({ data: result.data }));
                    setTotalPages(result.totalPages || 5); // Adjust based on your API response
                }
            })
            .catch(error => console.error("Error fetching categories: ", error));
    };

    useEffect(() => {
        fetchCategory();
    }, []);

    const selectCategory = (ctg) => {
        if (ctg.has_child) {
            fetchCategory(ctg.id);
            navigate('/products');
        } else {
            dispatch(setFilterCategory({ data: ctg.id }));
            navigate('/products');
        }
    };

    const openLink = (url) => {
        if (url) {
            window.open(url, "_blank");
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        // Fetch new data based on the page if necessary
        // Example: fetchCategory(page);
    };

    const SupportLinks = ({ supportNumber, supportEmail }) => {
        return (
            <div className='d-flex mt-5'>
                <span className='supportTxt mt-2' style={{ color: '#0d0d0e', fontWeight: 'bold' }}>
                    Click For Support
                </span>
                <a className='socical-icons'>
                    <img
                        src={whatsappimg}
                        alt="WhatsApp"
                        style={{ height: "25px", cursor: "pointer" }}
                        onClick={() => openLink(`https://web.whatsapp.com/send?phone=${supportNumber || "number"}&text=Hello!`)}
                    />
                </a>
                <a className='socical-icons'>
                    <img
                        src={contacticon}
                        alt="Phone"
                        style={{ height: "25px", cursor: "pointer" }}
                        onClick={() => openLink(`tel:${supportNumber || "#"}`)}
                    />
                </a>
                <a className='socical-icons'>
                    <img
                        src={envelope}
                        alt="Email"
                        style={{ height: "25px", cursor: "pointer" }}
                        onClick={() => openLink(`mailto:${supportEmail || "#"}`)}
                    />
                </a>
            </div>
        );
    };

    return (
        <>
            <div>
                <FooterBrand />
            </div>

            <div className="container-fluid">
                <div className="row p-3 backgroundfooter">
                    <div className="col-lg-3 col-sm-3 footerimages">
                        <img src={truck} alt="Fast Delivery" />
                        <p className="big-font">Fast Delivery</p>
                    </div>
                    <div className="col-lg-3 col-sm-3 footerimages">
                        <img src={updown} alt="Exchange Offer" />
                        <p className="big-font">Exchange Offer</p>
                    </div>
                    <div className="col-lg-3 col-sm-3 footerimages">
                        <img src={customerService} alt="24/7 Support" />
                        <p className="big-font">24*7 Support</p>
                    </div>
                    <div className="col-lg-3 col-sm-3 footerimages">
                        <img src={moneyBack} alt="Money Back" />
                        <p className="big-font">Money Back</p>
                    </div>
                </div>
            </div>
            <section id="footer">
                <div className="container pb-3">
                    <div className="row justify-content-evenly">
                        <div className="col-xs-2 col-sm-6 col-lg-2 col-md-6 col-12">
                            <h5 style={{ color: '#0d0d0e' }}>About Us</h5>
                            <ul className="link-list">
                                <li>
                                    <Link to="/about" className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })} >
                                        Our Story
                                    </Link>
                                </li>
                                <li><Link to={'/mission'} className="underline-link"onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}
                                >Mission & Values</Link></li>
                                <li><Link to={'/career'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}
                                >Careers</Link></li>
                                <li><Link to={'/press'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}
                                >Press</Link></li>
                            </ul>
                        </div>
                        <div className="col-xs-2 col-sm-6 col-lg-2 col-md-6 col-12">
                            <h5 style={{ color: '#0d0d0e' }}>Services & Policies</h5>
                            <ul className="link-list">
                                <li><Link to={'/contact'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}
                                >{t("contact_us")}</Link></li>
                                <li><Link to={'/faq'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("faq")}</Link></li>
                                <li><Link to={'/policy/ShippingPolicy'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("ShippingPolicy")}</Link></li>
                                <li><Link to={'/policy/ReturnsAndExchangesPolicy'} className="underline-link"onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("recharge_and_exchange_policy")}</Link></li>
                                <li><Link to={'/terms'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("terms_and_conditions")}</Link></li>
                                <li><Link to={'/policy/Privacy_Policy'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("privacy_policy")}</Link></li>
                                <li><Link to={'/policy/Cancellation_Policy'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("cancellation_policy")}</Link></li>
                                <li><Link to={'/categoryFeeCalculation'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>{t("Category Fee Calculation")}</Link></li>
                            </ul>
                        </div>
                        <div className="col-xs-2 col-sm-6 col-lg-2 col-md-6 col-12">
                            <h5 style={{ color: '#0d0d0e' }}>SHOP</h5>
                            <ul className="link-list">
                                <li>
                                    <Link
                                        to={'/products'} className="underline-link"
                                        onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}
                                    >
                                        Browse Products
                                    </Link>
                                </li>
                                <li><Link to={'/categories'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>Categories</Link></li>
                                <li><Link to={'/brands'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>Brands</Link></li>
                                <li><Link to={'/blogs'} className="underline-link" onClick={() => document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })}>Blogs</Link></li>
                            </ul>
                        </div>
                        <div className="col-xs-3 col-sm-6 col-md-6 col-lg-2 col-12 d-flex flex-column justify-content-between">
                            <div>
                                {setting.setting && (
                                    <div className="download_desc d-flex flex-column justify-content-start">
                                        <Link to='/' className='site-brand'>
                                            <img src={setting.setting.web_settings.web_logo} width="90px" alt="logo" className='desktop-logo hide-mobile' />
                                            <img src={setting.setting.web_settings.web_logo} width="80px" alt="logo" className='mobile-logo hide-desktop' />
                                        </Link>
                                        <div className='footer-logo1 mt-4' style={{ color: '#0d0d0e' }}>
                                            Security Certification
                                        </div>
                                        <div className='d-flex mt-4'>
                                            <img className='certificate' src={certi1} alt="certificate" />
                                            <img className='certificate' src={certi2} alt="certificate" />
                                            <img className='certificate' src={certi2} alt="certificate" />
                                        </div>
                                        <div className='d-flex mt-5'>
                                            <SupportLinks
                                                supportNumber={setting?.setting?.support_number}
                                                supportEmail={setting?.setting?.support_email}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='d-flex flex-column justify-content-start mt-3 mb-3'>
                                <div style={{ color: '#0d0d0e', marginBottom: "5px" }}>
                                    {setting.setting && setting.setting.web_settings.app_title}
                                </div>
                                <div className='gap-3 d-flex justify-content-start'>
                                    {setting.setting && (
                                        <div className='gap-3 d-flex justify-content-start'>
                                            {setting.setting.web_settings.is_android_app === "1" && (
                                                <a href={setting.setting.web_settings.android_app_url} className='download-button'>
                                                    <img src={setting.setting.web_settings.play_store_logo} alt='google-play' />
                                                </a>
                                            )}
                                            {setting.setting.web_settings.is_ios_app === "1" && (
                                                <a href={setting.setting.web_settings.ios_app_url} className='download-button'>
                                                    <img src={setting.setting.web_settings.ios_store_logo} alt='google-play' />
                                                </a>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="container flex-sm-row flex-column bottom-section-footer gap-5">
                        {setting.setting && setting.setting.social_media.length > 0 && (
                            <div className="social-media-icons order-sm-0" key={"icons"} style={{ marginLeft: '20px' }}>
                                <span>{t('follow_us')}:
                                    {setting.setting.social_media.map((icon, index) => (
                                        <a 
                                        key={index} 
                                        href={icon.link} 
                                        className='socical-icons' 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        style={{ textDecoration: "none" }} // Added inline style to remove underline
                                      >
                                        <i className={`${icon.icon} fa-lg`} style={{ color: "#fff" }}></i>
                                      </a>
                                      
                                    ))}
                                </span>
                            </div>
                        )}
                        <div className="copyright order-sm-1 order-2">
                            <div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center text-black">
                                <span className='company_name'>{setting.setting ? setting.setting.web_settings.copyright_details : "App Name"}</span>
                            </div>
                        </div>
                        <div className="payment_methods_container order-sm-1">
                            <span className='payment_methods'>
                                <img src={cod_svg} alt="Cash on Delivery" />
                            </span>
                            <span className='payment_methods'>
                                <img src={paypal_svg} alt="PayPal" />
                            </span>
                            <span className='payment_methods'>
                                <img src={upi_svg} alt="UPI" />
                            </span>
                            <span className='payment_methods'>
                                <img src={paytm_svg} alt="Paytm" />
                            </span>
                            <span className='payment_methods'>
                                <img src={razorpay_svg} alt="Razorpay" />
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};